__turbopack_context__.v({
  "table": "TableDesktop-module-scss-module__f1UUaq__table",
});
